// extracted by mini-css-extract-plugin
export var table = "ServiceRelatedTermsList-module--table--f84ef";